<template>
    <div v-if="list">
        <FaqItem
            v-for="(item, key) in list" 
            :key="key"
            :faqItem="item"
        />
    </div>
</template>

<script>
import FaqItem from './FaqItem.vue';
export default {
    name: "FaqList",
    props: {
        list: { type: Array, required: true }
    },
    components: { 
        FaqItem 
    }
}
</script>

<style lang="scss" scoped>
    @import "../style/Faq.scss";
</style>